import useFromAsset from './use-from-asset.js';
export const getExchangeFee = (params) => {
    const { fromAsset, quote } = params;
    const fee = quote?.exchangeFeeData?.feeOpts?.fee || fromAsset.feeAsset.currency.ZERO;
    if (quote?.exchangeFeeData?.extraFees) {
        const extraFees = Object.values(quote.exchangeFeeData.extraFees).reduce((extraFees, fee) => extraFees.add(fee), fromAsset.feeAsset.currency.ZERO);
        return fee.add(extraFees);
    }
    return fee;
};
const useExchangeFee = ({ quote }) => {
    const [fromAsset] = useFromAsset();
    return getExchangeFee({ fromAsset, quote });
};
export default useExchangeFee;
